// Single source of truth for the project set used on /vergleich.
// The dashboard chart averages across the same set, so both pages
// must read from this list.
export const VERGLEICH_PROJECTS = [
  {
    displayName: 'A 656 FDE Seckenheim FR Heidelberg',
    fullName: 'A 656 FDE Seckenheim FR Heidelberg konventionell',
  },
  {
    displayName: 'A 67 Lorsch FR FFM Notsanierung',
    fullName: 'A 67 Lorsch FR FFM Notsanierung konventionell',
  },
  {
    displayName: 'A 6 FBE AK Walldorf - AS Wiesloch Rauenberg FR HN',
    fullName: 'A 6 FBE AK Walldorf - AS Wiesloch Rauenberg FR HN CO2 Maßnahme',
  },
  {
    displayName: 'A 6 FBE AK Walldorf - AS Wiesloch Rauenberg FR MA',
    fullName: 'A 6 FBE AK Walldorf - AS Wiesloch Rauenberg FR MA CO2 Maßnahme',
  },
];

export const getProjectVariant = (fullName) => {
  if (!fullName) return null;
  if (fullName.includes('CO2 Maßnahme')) return 'CO2 SOLL';
  if (fullName.includes('konventionell')) return 'Konventionell';
  return null;
};
